import { Partner } from '@com-delta-omnichannel/aura';

export const Partners9ItemsMocks: Partner[] = [
  {
    id: 'earnMilesWithEveryLyft',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/lyft-logo.svg',
      alt: 'Lyft Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.deltalyft.com/'
    },
    title: 'Earn Miles With Every Lyft'
  },
  {
    id: 'earnMilesWithStarbucks',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/starbucks-logo.svg',
      alt: 'Starbucks Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.deltalyft.com/'
    },
    title: 'Earn Miles With Starbucks'
  },
  {
    id: 'earnMilesWithEveryOrder',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/instacart-logo.svg',
      alt: 'Instacart Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.delta.com/instacart'
    },
    title: 'Earn Miles With Every Order'
  },
  {
    id: 'EarnMileWithAirbnb',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/airbnb-logo.svg',
      alt: 'Airbnb Logo'
    },
    action: {
      label: 'Book Now',
      url: 'https://www.deltaairbnb.com'
    },
    title: 'Earn 1 Mile per $1 spent with Airbnb'
  },
  {
    id: 'earnMilesBookingWithTicketmaster',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/ticket-master-logo.svg',
      alt: 'Ticketmaster Logo'
    },
    action: {
      label: 'Buy Now',
      url: 'https://www.deltaticketmaster.com/'
    },
    title: 'Earn Miles Booking With Ticketmaster'
  },
  {
    id: 'earnMilesBookingWithHertz',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/hertz-logo.svg',
      alt: 'Hertz Logo'
    },
    action: {
      label: 'Book Now',
      url: 'https://www.delta.com/us/en/skymiles/medallion-program/elite-benefits-partners'
    },
    title: 'Earn Miles Booking With Hertz'
  },
  {
    id: 'earnMilesWithFTDFlowers',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/ftd-logo.svg',
      alt: 'FTD Flowers Logo'
    },
    action: {
      label: 'Order Now',
      url: 'https://www.skymilesshopping.com/me____.htm?gmid=4943'
    },
    title: 'Earn Miles With FTD Flowers'
  },
  {
    id: 'earnMilesStayingAtMarriottBonvoy',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/marriott-bonvoy-logo.svg',
      alt: 'Marriott Bonvoy Logo'
    },
    action: {
      label: 'Book Now',
      url: 'https://www.marriott.com/loyalty/earn/miles.mi'
    },
    title: 'Earn Miles Staying At Marriott Bonvoy'
  },
  {
    id: 'earnMilesStayingAtIHGHotels',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/ihg-logo.svg',
      alt: 'IHG Hotels Logo'
    },
    action: {
      label: 'Book Now',
      url: 'https://www.ihg.com/rewardsclub/content/us/en/earn-rewards/miles/deltaairlines'
    },
    title: 'Earn Miles Staying At IHG Hotels'
  }
];
